import React from "react";
import { baseURL, headers } from "../../global/api";
import { connect } from "react-redux";
import MaterialTable from "@material-table/core";
import Swal from 'sweetalert2'



export const deleteClientDetails = (id) => async (dispatch) => {
    try {
        const response = await fetch(`${baseURL}/user/delete-project/${id}`, {
            method: "DELETE",
            headers: headers,
        });
        const result = await response.json();
        if (response.ok) {
            Swal.fire("Deleted", "Project deleted successfully", "success");
        } else {
            Swal.fire("Error", result.message, "error");
        }
    } catch (error) {
        Swal.fire("Error", "Something went wrong", "error");
    }
};
export const updateClientDetails = (newData, oldData) => async (dispatch) => {
    try {
        const response = await fetch(`${baseURL}/user/update-project/${oldData._id}`, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(newData),
        });
        const result = await response.json();
        if (response.ok) {
            Swal.fire("Success", "Project Updated Successfully", "success");
        } else {
            Swal.fire("Error", result.message, "error");
        }
    } catch (error) {
        Swal.fire("Error", "Something went wrong", "error");
    }
};

const ViewProjcts = (props) => {

    return (
        <>
            <MaterialTable
                title="Project Details"
                columns={[
                    { title: "Client Name", field: "clientName" },
                    { title: "Domain", field: "domain" },
                    { title: "Expiry", field: "licenseExpiry" },
                ]}
                data={(query) =>
                    new Promise((resolve, reject) => {
                        let url = `${baseURL}/user/get-projects?`;
                        url += "limit=" + query.pageSize;
                        url += "&page=" + query.page;
                        url += "&search=" + query.search;
                        fetch(url, {
                            method: "GET",
                            headers: headers,
                        }).then((response) => response.json()).then((result) => {
                            resolve({
                                data: result.data,
                                page: result.page,
                                totalCount: result.totalResults,
                            });
                        });
                    })
                }
                options={{
                    actionsColumnIndex: -1,
                    exportButton: true,
                    paging: true,
                    pageSize: 50, // make initial page size
                    emptyRowsWhenPaging: false, // To avoid of having empty rows
                    pageSizeOptions: [50, 100, 150], // rows selection options
                    headerStyle: {
                        position: "sticky",
                        top: 0,
                        color: "#00BBBB",
                        fontWeight: "550",
                        onRowAdd: "none",
                    },
                }}
                editable={{
                    onRowUpdate: (newData, oldData) =>
                        new Promise((resolve, reject) => {
                            props.updateClientDetails(newData, oldData);
                            resolve();
                        }),

                    onRowDelete: (oldData) =>
                        new Promise((resolve, reject) => {
                            props.deleteClientDetails(oldData._id);
                            resolve();
                        }),
                }}
            />
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
        updateClientDetails: (newData, oldData) => dispatch(updateClientDetails(newData, oldData)),
        deleteClientDetails: (id) => dispatch(deleteClientDetails(id)),
    };
};
const mapStateToProps = (state, ownProps) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ViewProjcts);